import { gql } from '@apollo/client'

export const CREATE_POST_MUTATION = gql`
    mutation createPost($request: CreatePostRequest) {
        createPost(request: $request) 
    }
`
